import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import LandingPage from "@/pages/LandingPageMeta";
import BookingPage from "@/pages/BookingPage";
import SuccessPage from "@/pages/SuccessPage";
import CancelPage from "@/pages/CancelPage";
import WhatsAppConfirmation from "@/pages/WhatsAppConfirmation";
import CalendarPage from "@/pages/CalendarPage";
import AdminPage from "@/pages/AdminPage";
import GalleryPage from "@/pages/GalleryPage";
import ThankYouPage from "@/pages/ThankYouPage";
import SignatureQuotePage from "@/pages/SignatureQuotePage";
import BalancePaymentPage from "@/pages/BalancePaymentPage";
import LegalNoticePage from "@/pages/LegalNoticePage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPage from "@/pages/CookiesPage";
import { Toaster } from "@/components/ui/sonner";
import GlobalPromoBanner from "@/components/GlobalPromoBanner";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ConsentScripts from "@/components/ConsentScripts";

function App() {
  return (
    <div className="App" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Toaster position="top-right" />
      <ConsentScripts />
      <BrowserRouter>
        <GlobalPromoBanner />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/reserver" element={<BookingPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/whatsapp-confirmation" element={<WhatsAppConfirmation />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/galerie" element={<GalleryPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/merci" element={<ThankYouPage />} />
            <Route path="/signer-devis/:token" element={<SignatureQuotePage />} />
            <Route path="/paiement-solde/:token" element={<BalancePaymentPage />} />
            {/* Legal pages (Nov 2026) */}
            <Route path="/mentions-legales" element={<LegalNoticePage />} />
            <Route path="/politique-confidentialite" element={<PrivacyPage />} />
            <Route path="/cgv" element={<TermsPage />} />
            <Route path="/politique-cookies" element={<CookiesPage />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <CookieBanner />
    </div>
  );
}

export default App;
